import {styled, css} from "styled-components";

export const ButtonColoring = css`
	&:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}
	&:active {
		background-color: rgba(0, 0, 0, 0.2);
	}
`;

export const BorderlessButton = styled.button`
	background-color: rgba(0, 0, 0, 0);
	/* &:hover {
		background-color: rgba(0, 0, 0, 0.1);
		color: darkgreen;
	} */
	${ButtonColoring}
	border: none;
`;

export const BorderlessCancelButton = styled(BorderlessButton)`
	&:hover {
		color: red;
	}
`;

export const Literal = styled.span`
	font-family: monospace;
`;

export const SizeAdjustedLowercaseLiteral = styled(Literal)`
	font-size: 120%;
`;

export const LiteralBlock = styled.div`
	font-family: monospace;
`;

export const ReportContainer = styled.div`
	width: 90vw;
	display: block;
	overflow-x: clip;
	padding-left: 5rem;
	padding-right: 5rem;
`

export const SearchDetails = styled.details`
	min-width: 0;
`;

export const SubSection = styled.section`
	min-width: 0;
	margin-left: 1rem;
`;

export const IndentedBlock = styled.div`
	min-width: 0;
	margin-left: 1rem;
`;

export const ContextSpan = styled(Literal)`
	color: rgba(128,128,128,0.5);
`;

export const EmphasizedResultSpan = styled(Literal)`
	background-color: rgba(255,255,0,0.1);
`

export const TimeStampElement = styled.span`
	font-size: 60%;
	color: rgba(128,128,128,1);
	padding-left: 2px;
	padding-right: 2px;
	margin-right: 0.15rem;
	border-right: 1px solid rgba(128,128,128,0.5);
`

export const ReportSection = styled.section`
	min-width: 0;
	flex-direction: column;
	align-items: flex-start;
	:not(:first-child) {
		/* margin-top: 0.5rem; */
	}
	margin-bottom: 2rem;
`;

export const Report = styled.section`
  @media print {
		page-break-after: always;
	}
`;


export const ReportTitle = styled.h1`
	font-size: 180%;
`

export const ReportSubtitle = styled.h2`
`

export const ReportSectionHeader = styled.h2`
	margin-top: 0.1rem;
	margin-bottom: 0px;
`;

export const ReportSubSectionHeader = styled.h3`
	margin-top: 0.05rem;
	margin-top: 0px;
margin-bottom: 0px;
`;

export const ReportSubSubSectionHeader = styled.h4`
font-size: 115%;
margin-top: 0px;
margin-bottom: 0px;
`;

export const SearchTermFoundLine = styled.div`
	min-width: 0;
`;

export const SearchTermFoundSpan = styled.span`
	font-size: 115%;
	font-family: monospace;
	font-weight: bold;
	min-width: 0;
`;

export const SearchResultFoundLine = styled.div`
	min-width: 0;
`;

export const SearchResultEncodingFoundSpan = styled(Literal)`
	font-weight: bold;
`;

// export const ReportSubSectionHeader = styled.div`
// 	font-size: 105%;
// 	font-weight: bold;
// `;

export const SearchLocationLine = styled.div`
	min-width: 0;
	font-size: 85%;
`;

export const ContextLine = styled.div`
	min-width: 0;
	font-size: 75%;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow-x: hidden;
`;

export const InferredTypeName = styled.span`
	font-family: monospace;
	font-style: italic;
	color: rgba(96, 32, 32, 1);
`

export const InferredTypeNameBlock = styled.div`
`

export const InferredTypeNameSpan = styled.span`
`
